import type { CompanyAccountActionResult, CompanyAccountStatus } from '@open-design/contracts';

export async function companyAccountRequest<T = CompanyAccountStatus>(action: string, body?: object): Promise<T> {
  const response = await fetch(`/api/company-auth/${action}`, {
    method: body ? 'POST' : 'GET',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: body ? { 'Content-Type': 'application/json' } : {},
    ...(body ? { body: JSON.stringify(body) } : {}),
    signal: AbortSignal.timeout(20_000),
  });
  const result = await response.json().catch(() => null);
  if (!response.ok) throw new Error(result?.error?.message ?? '暂时无法连接账号服务，请稍后重试');
  if (!result) throw new Error('账号服务响应异常，请稍后重试');
  return result as T;
}

export const companyAccountAction = (action: string, body: object) => companyAccountRequest<CompanyAccountActionResult>(action, body);
